import { forwardRef, type Ref, type SVGProps } from "react";
const IconAppHeartFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.476 2h13.048a1.87 1.87 0 0 1 1.864 1.867v24.266A1.87 1.87 0 0 1 22.524 30H9.476a1.87 1.87 0 0 1-1.864-1.867V3.867A1.87 1.87 0 0 1 9.476 2m3.98 3.03a.933.933 0 1 1-1.865 0 .933.933 0 0 1 1.866 0m3.729.933H15.32a.933.933 0 0 1 0-1.867h1.864a.933.933 0 0 1 0 1.867m-.932 21.36a.933.933 0 1 0-.002-1.865.933.933 0 0 0 .002 1.865m5.722-13.473c0 .7-.3 1.4-.8 2l-5.1 5.1-5.1-5.1c-.5-.5-.8-1.2-.8-2s.3-1.5.8-2 1.3-.8 2-.8 1.4.3 2 .8l1.2 1.2 1.2-1.2c1.1-1.1 2.9-1.1 4 0 .4.6.6 1.3.6 2"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAppHeartFilledSVG);
ForwardRef.displayName = "IconAppHeartFilled";
export { ForwardRef as IconAppHeartFilled };
